{
    "DAYS": "أيام",
    "HOURS": "ساعات",
    "MINUTES": "دقائق",
    "SECONDS": "ثواني",
    "STARTING_SOON": "يبدأ قريبا...",
    "EVENT_NOT_STARTED": "هذا الحدث لم يبدأ بعد...",
    "DEFAULT_ERROR": "خطأ في التشغيل",
    "DEFAULT_ERROR_DESCRIPTION": "غير قادر على تشغيل الفيديو. يرجى المحاولة مرة أخرى لاحقًا.",
    "API_ERROR": "فشل في استرجاع معلومات الفيديو",
    "API_ERROR_DESCRIPTION": "خطأ في جلب تفاصيل الفيديو. تحقق من معرف الفيديو واتصال الإنترنت وحاول مرة أخرى.",
    "ERROR_CODE_NOT_AUTHENTICATED": "تفويض",
    "ERROR_CODE_NOT_AUTHENTICATED_DESCRIPTION": "ليس لديك إذن لتشغيل هذا الفيديو.",
    "ERROR_CODE_GEO_BLOCKED": "قيود الجغرافيا",
    "ERROR_CODE_GEO_BLOCKED_DESCRIPTION": "عذرًا، هذا الفيديو غير متاح في منطقتك بسبب قيود الجغرافيا.",
    "ERROR_CODE_NOT_ENTITLED": "غير مخول",
    "ERROR_CODE_NOT_ENTITLED_DESCRIPTION": "عذرًا، ليس لديك الحق في تشغيل هذا الفيديو.",
    "ERROR_CODE_VPN_BLOCKED": "تم حظر VPN",
    "ERROR_CODE_VPN_BLOCKED_DESCRIPTION": "هذا الفيديو غير متاح بسبب استخدام VPN.",
    "ERROR_CODE_IP_CHANGED": "تغيير الشبكة",
    "ERROR_CODE_IP_CHANGED_DESCRIPTION": "لقد انتقلت إلى شبكة مختلفة بشكل غير متوقع. يرجى المحاولة مرة أخرى.",
    "ERROR_CODE_VPN_DETECTED": "تم اكتشاف VPN",
    "ERROR_CODE_VPN_DETECTED_DESCRIPTION": "لقد اكتشفنا وجود VPN. يرجى إيقاف تشغيله والمحاولة مرة أخرى.",
    "ERROR_CODE_ANONYMOUS_PROXY": "تم اكتشاف بروكسي مجهول",
    "ERROR_CODE_ANONYMOUS_PROXY_DESCRIPTION": "لقد اكتشفنا بروكسي مجهولاً أو خادماً. يرجى إيقاف تشغيله والمحاولة مرة أخرى.",
    "CONCURRENCY_KICKED": "تم الوصول إلى الحد الأقصى للأجهزة",
    "CONCURRENCY_KICKED_DESCRIPTION": "لقد تجاوزت الحد الأقصى للأجهزة المسموح لها بمشاهدة هذا الفيديو في نفس الوقت.",
    "CONCURRENCY_CONNECTION_FAILED": "خطأ في الاتصال",
    "CONCURRENCY_CONNECTION_FAILED_DESCRIPTION": "تعذر إنشاء اتصال. يرجى المحاولة مرة أخرى."
}
